import script from "./AddOrganization.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddOrganization.vue?vue&type=script&setup=true&lang=ts"

import "./AddOrganization.vue?vue&type=style&index=0&id=466a4624&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466a4624"]])

export default __exports__